import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ["submitButton", "saveButton"]

  submitEssay() {
    const buttonId = this.submitButtonTarget.dataset.submitButtonId
    document.getElementById(buttonId).click()
  }

  saveEssay() {
    const buttonId = this.saveButtonTarget.dataset.saveButtonId
    document.getElementById(buttonId).click()
  }
}